interface CapturedTarget {
    type: string;
    startTime: number;
    target: HTMLElement | null;
}

/** Отслеживаемые события */
const EVENT_TYPES = ['pointerdown', 'pointerup', 'click', 'keydown', 'keyup', 'keypress'] as const;
/** Количество событий в буфере */
const EVENTS_BUFFER_LENGTH = 30;
/** Максимальная погрешность по времени при поиске target для события */
const SEARCH_MAX_DIFF_MS = 50;

const capturedInteractionTargets: CapturedTarget[] = [];

/**
 * Начать собирать targets в событиях интерактивности.
 * Ранний сбор нужен для корректной атрибуции, даже если элемент перерендерился.
 */
export function startCapturingInteractionTargets() {
    EVENT_TYPES.forEach(type => {
        document.addEventListener(type, captureInteractionTarget, true);
    });

    return () => {
        capturedInteractionTargets.length = 0;

        EVENT_TYPES.forEach(type => {
            document.removeEventListener(type, captureInteractionTarget, true);
        });
    };
}

/**
 * Получить target из PerformanceEventTiming.
 * Если target в событии пустой, подберется наиболее подходящий по времени из собранных интеракций.
 * @param entry entry из PerformanceObserver
 * @returns подходящий target или null
 */
export function getEntryTarget(entry: Ya.Rum.PerformanceEventTiming) {
    if (entry.target) {
        return entry.target;
    }

    let bestMatch: CapturedTarget | null = null;
    let bestMatchDiff = SEARCH_MAX_DIFF_MS;

    for (const interactionTarget of capturedInteractionTargets) {
        if (interactionTarget.type === entry.name) {
            const diff = Math.abs(interactionTarget.startTime - entry.startTime);
            if (diff < bestMatchDiff) {
                bestMatchDiff = diff;
                bestMatch = interactionTarget;
            }
        }
    }
    return bestMatch ? bestMatch.target : null;
}

const captureInteractionTarget = (event: Event) => {
    if (capturedInteractionTargets.length >= EVENTS_BUFFER_LENGTH) {
        capturedInteractionTargets.shift();
    }

    if (!(event.target instanceof HTMLElement)) {
        return;
    }

    capturedInteractionTargets.push({
        type: event.type,
        startTime: performance.now(),
        target: event.target,
    });
};
